// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.4297 2.72189L11.9998 2.5L11.57 2.72189C10.4844 3.28225 9.50022 4.014 8.65248 4.88193C9.89759 5.5364 11.0266 6.38507 12.0001 7.38817C12.9735 6.38516 14.1024 5.53656 15.3474 4.88212C14.4996 4.0141 13.5154 3.28229 12.4297 2.72189ZM10.7716 8.84937C9.15651 7.13352 7.01924 5.92278 4.61507 5.47688L3.5 5.27007V12.9174C3.5 16.5455 5.7295 19.6478 8.8806 20.9036C8.45335 19.591 8.22222 18.1886 8.22222 16.7317C8.22222 13.7834 9.1687 11.0583 10.7716 8.84937ZM20.5 5.27007L19.3849 5.47688C14.1089 6.45543 10.1111 11.1213 10.1111 16.7319C10.1111 18.1967 10.3841 19.5993 10.8824 20.8893L11.1093 21.4764C11.406 21.4857 11.7031 21.5 12 21.5C16.6945 21.5 20.5 17.6575 20.5 12.9174V5.27007Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
